var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('editor',{attrs:{"init":_vm.init},model:{value:(_vm.editorValue),callback:function ($$v) {_vm.editorValue=$$v},expression:"editorValue"}}),_c('div',{staticClass:"d-flex justify-content-end text-secondary"},[_vm._v(_vm._s(_vm.currentLength +' / '+ _vm.maxLength))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }